import { IOption } from "../types/IOption";

export const statesOfArgentina: IOption[] = [
  { label: "Buenos Aires", value: "Buenos Aires" },
  { label: "Ciudad Autónoma de Buenos Aires", value: "Ciudad Autónoma de Buenos Aires" },
  { label: "Catamarca", value: "Catamarca" },
  { label: "Chaco", value: "Chaco" },
  { label: "Chubut", value: "Chubut" },
  { label: "Córdoba", value: "Córdoba" },
  { label: "Corrientes", value: "Corrientes" },
  { label: "Entre Ríos", value: "Entre Ríos" },
  { label: "Formosa", value: "Formosa" },
  { label: "Jujuy", value: "Jujuy" },
  { label: "La Pampa", value: "La Pampa" },
  { label: "La Rioja", value: "La Rioja" },
  { label: "Mendoza", value: "Mendoza" },
  { label: "Misiones", value: "Misiones" },
  { label: "Neuquén", value: "Neuquén" },
  { label: "Río Negro", value: "Río Negro" },
  { label: "Salta", value: "Salta" },
  { label: "San Juan", value: "San Juan" },
  { label: "San Luis", value: "San Luis" },
  { label: "Santa Cruz", value: "Santa Cruz" },
  { label: "Santa Fe", value: "Santa Fe" },
  { label: "Santiago del Estero", value: "Santiago del Estero" },
  { label: "Tierra del Fuego", value: "Tierra del Fuego" },
  { label: "Tucumán", value: "Tucumán" },
];
